(function() {
    var globals = require("./modules/globals.js")
    var graph = require("./modules/graph.js")
    var handlers = require("./handlers.js")
    var analyse = require("./modules/analyse.js")
    var utils = require("./modules/utils.js")

    module.exports = {
	init: init,
	updateNetwork: updateNetwork,
	updateCategories: updateCategories,
	updateEvents: updateEvents,
	updateTimeScale: updateTimeScale,
	checkCats: checkCats,
	resetCategories: resetCategories,
    }

    var protagonists = {M: 'Manquilef', AP: 'Aburto Panguilef', C: 'Coñuepán'}
    var currentCats = [];
    
    var svg = d3.select("svg#timeline"),
	width = +svg.node().getBoundingClientRect().width,
	height = +svg.node().getBoundingClientRect().height;

    var base = window.innerWidth < 1400 ? 2.5 : 5;

    
/*    var simulation = d3.forceSimulation()
	.force("collide", d3.forceCollide(5).iterations(20))
	.force("charge", d3.forceManyBody().strength(-5))
	.force("link", d3.forceLink().id(function(d) { return d.id; }))
*/
    var simulation;
    
    var eventsLayer = svg.append("g")
	.attr("class", "events")

    var events = eventsLayer.selectAll("ellipse")
    
    var linksLayer = svg.append("g")
	.attr("class", "links")
    .style("pointer-events", "none");

    var links = linksLayer.selectAll("line");
    
    var nodesLayer = svg.append("g")
	.attr("class", "people");

    var nodes = nodesLayer.selectAll("circle")
    
    var timeScaleLayer = svg.append("g")
	.attr("class", "timeScale")

    var timescale = timeScaleLayer.selectAll("text")

    var notches = timeScaleLayer.selectAll("line")

    var timebasline = svg.append("line")

    var categoriesLayer = svg.append("g")
	.attr("class", "categories");

    var categories = categoriesLayer.selectAll("text")

    var catWidth = window.innerWidth < 1400 ? 100 : 130;

 //   var infoLayer = svg.append("g")
//		.attr("class", "infoLayer");
    var infoLayer = d3.select("div.infoLayer")
	var info = infoLayer.selectAll("div.item-bubble")
	var related = infoLayer.selectAll("div.related")
    var wH;

    function init(data, wHeight) {

        wH = wHeight;
	simulation =  d3.forceSimulation()
	    .force("collide", d3.forceCollide(5).iterations(20))
	    .force("charge", d3.forceManyBody().strength(-5))
	    .force("link", d3.forceLink().id(function(d) { return d.id; }))
	
	unit = (wHeight - 100) / 6;
	globals.yAxis = {"M":{yVal:unit + 50}, "AP":{yVal:unit*3},"C":{yVal:(unit*5) -50}};

	for(type in globals._data.master.eventTypes) {
	    currentCats.push({title: globals._data.master.eventTypes[type].title, active:true});
	}
	
//	var categoriesScale = d3.scaleOrdinal([0, data.eventTypes[data.eventTypes.length -1]])
    
	categories = categoriesLayer.selectAll("text")
	    .data(data.eventTypes)
	    .enter().append("text") 
	    .text(function(d) { return "#" + d.title; })
	    .attr("y", 40)
	    .attr("x", 0)
		.attr("kerning", "15px")
//	    .attr("font-size", 20)
	    .attr("fill", function(d) { return globals.units.color(d.color); })
	    .attr("transform", function(d, i) { return "translate("  + (i+1) * catWidth  + ",0)"; })
	    .attr("opacity", 0.7)
	    .on("click", categoryClick)
	      

	nodes = nodesLayer.selectAll("circle")
	    .data(globals._data.nodesData)
	    .enter().append("circle")
	    .attr("r", base)
	    .attr("fill", "white")
	    .attr("opacity", 0.7);
	
	links = linksLayer.selectAll("line")
	    .data(globals._data.linksData)
	    .enter().append("line")
	    .attr("stroke-width", 1)
	    .attr("stroke", "white")
	    .attr("opacity", 0.3);

//	nodesData = __data.events;
	globals._data.nodesData = data.events;
    
	events = eventsLayer.selectAll("ellipse")
	    .data(globals._data.nodesData.filter(function(d) { return d.type =='event';}))
	    .enter().append("ellipse")
	    .attr("ry", function(d) { return window.innerWidth < 1400 ? 5 * d.datasets.length : 7 * d.datasets.length; })
	    .attr("rx", function(d) { return graph.getRx(d.startDate, d.endDate, d.datasets); })
	    .attr("fill", function(d) { return globals.units.color(globals._data.master.eventTypes.filter(function(e) { return e.title == d.eventType;})[0].color); })
	    .attr("cx", function(d) { return d.x; })
	    .attr("cy", function(d) { return d.y; })
	    .attr("opacity", function(d) { return graph.getOpacity(d.ongoing);})
	    .attr("id", function(d) { return d.id; })
	    .on("click", eventClick);
	
	events.append("title")
	    .text(function(d) { return d.eventName; });
	
	timeScale = timeScaleLayer.selectAll("text")
	    .data(globals._data.datesData)
	    .enter().append("text")
	    .attr("x", function(d) { return d.x + 5; })
	    .attr("y", wHeight - 80)
	    .attr("fill", "white")
	    .attr("font-size", "0.85em")
	    .attr("opacity", 0.9)
	    .text(function(d) { return d.year;});
	
	notches = timeScaleLayer.selectAll("line")
	    .data(globals._data.datesData)
	    .enter().append("line")
	    .attr("x1", function(d) { return d.x; })
	    .attr("y1", wHeight - 75)
	    .attr("x2", function(d) { return d.x; })
	    .attr("y2", function(d) { return d.timebreak ? 50 : wHeight - 90; })
	    .attr("stroke-width", 1)
	    .attr("stroke", "white")
	    .style("stroke-dasharray", function(d) { return d.timebreak ? "3, 7" : "3, 0"; })
	    .attr("opacity", function(d) { return d.timebreak ? 0.57 : 0.8; })

	timeBaseLine = svg.append("line")
	    .attr("x1", globals._data.datesData[0].x)
	    .attr("x2", globals._data.datesData[globals._data.datesData.length -1].x)
	    .attr("y1", wHeight - 75)
	    .attr("y2", wHeight - 75)
	    .attr("stroke-width", 1)
	    .attr("stroke", "white")
	    .attr("opacity", 0.8)

		console.log(globals._data.datesData)
    
	simulation
	    .nodes(globals._data.nodesData)
	    .on("tick", ticked);
	
    }
    
    function ticked2() {
  
	events
            .attr("cx", function(d) { return d.x; })
            .attr("cy", function(d) { return d.y; });
	
    }
    
    function ticked() {
	events
            .attr("cx", function(d) { return d.x; })
            .attr("cy", function(d) { return d.y; });
	
	links
            .attr("x1", function(d) { return d.source.x; })
            .attr("y1", function(d) { return d.source.y; })
            .attr("x2", function(d) { return d.target.x; })
            .attr("y2", function(d) { return d.target.y; });

	nodes
            .attr("cx", function(d) { return d.x; })
            .attr("cy", function(d) { return d.y; });
    }

    function updateNetwork() {
        fixEvents()

        simulation.force("charge").strength(-30);

        nodes = nodes.data(globals._data.nodesData.filter(function(d) { return d.type == 'person'; }))
        nodes.exit().remove()
        nodes
            .attr("r", function(){ return window.innerWidth<1400?4:5})
            .attr("fill", "rgb(150,200,229)")
            .attr("opacity", 0.9)
            .attr("id", function(d) { return d.id; })
            .on("click", eventClick)

        nodes = nodes.enter().append("circle")
            .attr("r", window.innerWidth<1400?4:5)
            .attr("fill", "rgb(150,200,229)")
            .attr("opacity", 0.9)
            .attr("id", function(d) { return d.id; })
            .on("click", eventClick)
            .merge(nodes);

        nodes.append("title")
            .text(function(d) { return d.name; });

        links = links.data(globals._data.linksData)
        links.exit().remove()

        links
            .attr("stroke-width", 1)
            .attr("stroke", "white")
            .attr("opacity", 0.3)

        links = links.enter().append("line")
            .attr("stroke-width", 1)
            .attr("stroke", "white")
            .attr("opacity", 0.3)
            .merge(links);

        simulation
            .nodes(globals._data.nodesData);

        simulation.force("link")
            .links(globals._data.linksData);

        simulation.alpha(1).restart()
    }

    function categoryClick(d) {
        d.active = d.active ? false : true;
        updateCategories();
    }

    function resetCategories() {
        globals._data.master.eventTypes.forEach(function(d) {
            d.active =true;
        });
        updateCategories();
    };
    
    function updateCategories() {
        categories
            .attr("opacity", function(d) { return d.active ? 0.8 : 0.5; })
            .attr("text-decoration", function(d) { return d.active ? "underline" : "none";})

        currentCats = []
        globals._data.master.eventTypes.forEach(function(d) {
            if(d.active == true) {
                currentCats.push(d)
            }
        });

        fixEvents();

        analyse.filterEvents(currentCats);

        updateEvents();
    }

    function updateEvents() {

        analyse.filterEvents(currentCats)
        simulation.force("charge").strength(-5);

        events = events.data(globals._data.nodesData.filter(function(d) { return d.type == 'event';}))
        events.exit().transition().attr("opacity",0).remove()

        graph.createTimescale(globals._data.nodesData.filter(function(d) { return d.type === 'event';}))
        updateTimeScale();

        events
            .attr("ry", function(d) { return window.innerWidth < 1400 ? 5 * d.datasets.length : 7 * d.datasets.length; })
            .attr("rx", function(d) { return graph.getRx(d.startDate, d.endDate, d.datasets); })
            .attr("cx", function(d) { return graph.getX(d); })
            .attr("cy", function(d) { return graph.getY(d.startDate, d.endDate, d.datasets); })
            .attr("fill", function(d) { return globals.units.color(globals._data.master.eventTypes.filter(function(e) { return e.title == d.eventType;})[0].color); })
            .attr("opacity", 0)
            .attr("id", function(d) { return d.id; })
            .on("click", eventClick)

//	events.transition().duration(1000).style("opacity", function(d) {  return graph.getOpacity(d.ongoing);})

        events = events.enter().append("ellipse")
            .attr("ry", function(d) { return 7 * d.datasets.length; })
            .attr("rx", function(d) { return graph.getRx(d.startDate, d.endDate, d.datasets); })
            .attr("cx", function(d) { return graph.getX(d); })
            .attr("cy", function(d) { return graph.getY(d.startDate, d.endDate, d.datasets); })
            .attr("fill", function(d) { return globals.units.color(globals._data.master.eventTypes.filter(function(e) { return e.title == d.eventType;})[0].color); })
            .attr("opacity", 0)
            .attr("id", function(d) { return d.id; })
            .on("click", eventClick)
            .merge(events);

        events.transition().attr("opacity", function(d) {  return graph.getOpacity(d.ongoing);});

        events.select("title")
            .text(function(d) { return d.eventName; });

        simulation
            .nodes(globals._data.nodesData);

        simulation.force("link")
            .links(globals._data.linksData);

        simulation.alpha(0.3).restart()

        updateNetwork();


    };

    function updateTimeScale() {
        console.log(globals._data.datesData)

        timeScale = timeScale.data(globals._data.datesData)
        timeScale.exit().remove()
        timeScale.text(function(d) { return d.year; })
        timeScale = timeScale.enter().append("text")
            .attr("x", function(d) { return d.x + 5; })
            .attr("y", wH - 80)
            .attr("fill", "white")
            .attr("font-size", "0.85em")
            .attr("opacity", 0.9)
            .text(function(d) { return d.year;})
            .merge(timeScale)

        notches = notches.data(globals._data.datesData)
        notches.exit().remove()
        notches
            .attr("y2", function(d) { return d.timebreak ? 50 : wH - 90; })
            .style("stroke-dasharray", function(d) { return d.timebreak ? "3, 7" : "3, 0"; })
            .attr("opacity", function(d) { return d.timebreak ? 0.57 : 0.8; })

        notches = notches.enter().append("line")
            .attr("x1", function(d) { return d.x; })
            .attr("y1", wH - 75)
            .attr("x2", function(d) { return d.x; })
            .attr("y2", function(d) { return d.timebreak ? 50 : wH - 90; })
            .attr("stroke-width", 1)
            .attr("stroke", "white")
            .style("stroke-dasharray", function(d) { return d.timebreak ? "3, 7" : "3, 0"; })
            .attr("opacity", function(d) { return d.timebreak ? 0.57 : 0.8;})
            .merge(notches)

        timeBaseLine
            .attr("x1", globals._data.datesData[0].x)
            .attr("x2", globals._data.datesData[globals._data.datesData.length -1].x)
    }

    var theta = [0, Math.PI / 6, Math.PI / 4, Math.PI / 3, Math.PI / 2, 2 * (Math.PI / 3), 3 * (Math.PI / 4), 5 * (Math.PI / 6), Math.PI, 7 * (Math.PI / 6), 5 * (Math.PI / 4), 4 * (Math.PI / 3), 3 * (Math.PI / 2), 5 * (Math.PI / 3), 7 * (Math.PI / 4), 11 * (Math.PI / 6)];

    var currentEvent;

    function eventClick(d) {

        $(".selected").removeClass("selected");
        $("#"+d.id).addClass("selected");

        if(d.id.substr(0,3) === "evt") {
            if (d.startDate != '') {
                eventDate = d.startDate + " - " + d.endDate;
            } else {
                eventDate = d.date;
            }

            eventData = {
                name: d.eventName,
                venue: d.venue,
                /*	    image: d.image,
                venue: d.venue,
                location: d.location,
                notes: d.notes,
                category: d.eventType,
                pSource: d.pSource,
                sSource: d.sSource,*/
                date: eventDate,
//	    color:globals.units.color(eventTypes[d.eventType].color),
                id: d.id,
                copy: globals.copy,
                relSources: d.relMedia,
            }
        } else {
        	eventData = {
        		name: d.name,
				id: d.id,
				relSources: d.relMedia,
				copy: globals.copy,
				image: d.image,
			}
		}

        initBubbles(eventData);
/*        $.ajax({
            url:'templates/eventInfo.html',
            cache:false,
        }).done(function(data) {
            $('#timeline-container').append(Mustache.render(data, eventData));
            $(".info-container").css("left", eventX+"px").css("top", eventY+"px")
            $(".info-container").fadeIn();
            $(".close-btn").click(function() {
                $(this).parent().parent().fadeOut(500, function() { $(this).remove() });
                $(".selected").removeClass("selected");
            });
            $(".action-btn.toggle-event-connections").click(function() {
                eventId = $(this).parent().parent().attr("data-eventid");
                $("#"+eventId).toggleClass("active");
                if($("#"+eventId).hasClass("active") == true) {
                    el = analyse.findAttendees(eventId, globals._data);
                    globals._data.nodesData = globals._data.nodesData.concat(el.newPeople)
                    globals._data.linksData = globals._data.linksData.concat(el.newLinks);
                    updateNetwork();
                } else {
                    globals._data.linksData = globals._data.linksData.filter(function(d) { return d.target.id != eventId;})
                    el = graph.removeUnlinkedPeople(globals._data.nodesData, globals._data.linksData);
                    globals._data.linksData = linksData = el.links;
                    globals._data.nodesData = el.nodes;
                    updateNetwork();
                }
                $(this).parent().parent().fadeOut(500, function() { $(this).remove() });
                $(".selected").removeClass("selected");
            });
        }); */
    }

    function initBubbles(itemData) {
        $(".infoLayer").fadeIn()
		$("#timeline-controls").fadeOut();
        currentEvent = itemData.id;

        if(currentEvent.substr(0,3) === "per") {
            classRef = 'person';
            labelTxt = globals.copy.showLinksBtn;
        } else {
            classRef = 'event';
            labelTxt = globals.copy.showAttendeesBtn;
        }
        console.log(itemData)
        mainBubble = infoLayer.selectAll("div.main-info-bubble")
            .data([{target:itemData}])
            .enter().append("div")
            .attr("id", "first-bubble")
            .attr("class", "main-info-bubble central-bubble " + classRef)
            //	.attr("class", "central-bubble")
            //			.enter().append("circle")
            .style("position", "absolute")
            .style("left", window.innerWidth/2 - 150 + "px")
            .style("top", window.innerHeight/2 - 150 + "px")

        mainBubble.append("div")
            .attr("class", "bubble-image main")
            .style("background-image", function(d) {
                if(currentEvent.substr(0,3) === 'per') {
                    img = itemData.image;
                  /*  if (img !== "person") {
                        return "url(media/images/" + img + ".png)";
                    } else {
                        return ""
                    }*/
                    return "url(media/images/" + img + ".png)";
                } else {
                    return ""
                }
            })

		mainBubble.append("div")
			.attr("class", "data-container main")

		if(itemData.id.substr(0,3) === "evt") {
            mainBubble.select(".data-container.main").append("p")
                .attr("class", "info-date")
                .html(itemData.date);
        }

        mainBubble.select(".data-container.main").append("p")
            .attr("class", "info-name")
            .html(itemData.name);

        if(itemData.id.substr(0,3) === "evt") {
            mainBubble.select(".data-container.main").append("p")
                .attr("class", "info-venue")
                .html(itemData.venue);
        }

        utils.verticalCenter($(".data-container.main"), $(".main-info-bubble"))

        if(itemData.id.substr(0,3) === "per") {
            addPersonInfo(globals._data.master.people.filter(function(d) { return d.id === itemData.id})[0])
        };
   //     attendeesButton = infoLayer.selectAll("div")
           // .data(eventData.id)
     //       .enter().append("div")
		attendeesButton = infoLayer.append("div")
            .attr("class", "bubble-button attendees-button")
            .style("position", "absolute")
            .style("left", (window.innerWidth/2 - 40) + (150 * Math.cos(theta[2])) + "px")
            .style("top", (window.innerHeight/2 - 40) - (150 * Math.sin(theta[2])) + "px")
            .on("click", showLinksClick)

        attendeesButton.append("p")
            .attr("class", "button-label")
            .html(labelTxt)


        backToTimeline = infoLayer.append("div")
            .attr("class", "main-info-bubble back")
            .style("position", "absolute")
            .style("left", window.innerWidth - 150 + "px")
            .style("top", -100 + "px")
            .on("click", closeInfo);


        backToTimeline.append("p")
            .html("Back to timeline")


        relatedSources = infoLayer.append("div")

        if(itemData.relSources.length > 0) {
            showRelSources(itemData.relSources);
        }
	}

    function showRelSources(sourceData) {
        relatedSources = infoLayer.append("div")
            .attr("class", "main-info-bubble related")
            .style("position", "absolute")
            .style("left", window.innerWidth - 150 + "px")
            .style("top", window.innerHeight - 150 + "px");

        relatedSources.append("p")
            .html(globals.copy.relatedMedia)

        rSources = related.data(sourceData)
            .enter().append("a")
			.attr("href", function(d) { return "#/explore/archive/" + d.id; })
			.append("div")
            .attr("class", "item-bubble related")
            .style("position", "absolute")
            .style("top", window.innerHeight + "px")
            .style("left", window.innerWidth + "px")


        rSources.append("div")
            .attr("class", "bubble-image")
            .style("background-image", function (d) {
                return "url(media/images/" + d.filename + "_BW.png)"
            })
      /*      .append("p")
            .html(function (d) {
                return d.title;
            })
*/
        rSources.append("div")
			.attr("class", "data-container")
			.append("p")
            .html(function (d) {
                return d.title;
            })

		$(".related .data-container").each(function() {
			utils.verticalCenter($(this), $(this).parent())
		})

        rSources.transition(1500)
            .delay(500)
            .style("left", function (d, i) {
                return window.innerWidth - (350 * Math.cos(theta[i * 2 + 1])) + "px";
            })
            .style("top", function (d, i) {
                return window.innerHeight - (350 * Math.sin(theta[i * 2 + 1])) + "px";
            })
			.on("end", function() {
				if(sourceData.length > 2) {
                    $("#related-down-arrow").attr("data-len", sourceData.length).fadeIn();
                }
			})
	}

    function closeInfo() {
        rotation = 0;
        relatedRotation = 0;
        linksVisible = false;
    	$(".infoLayer").fadeOut(function() {
    		$(this).html("<div class=\"back-to-timline-txt\">\n" +
                globals.copy.backTo +
                "        </div>")
		})
		$(".arrow").fadeOut();
		$("#timeline-controls").fadeIn();
	}

	var linkBubbles;


    function findItemData() {
        linkData = globals._data.master.links.filter(function(l) {
            if(currentEvent.substr(0,3) === 'per') {
                if (typeof l.source === 'string') {
                    return l.source === currentEvent;
                } else {
                    return l.source.id === currentEvent;
                }
            } else if(currentEvent.substr(0,3) === 'evt') {
                if(typeof l.target === 'string') {
                    return l.target === currentEvent;
                } else {
                    return l.target.id === currentEvent;
                }
			}
        });

        linkPeople = []
        linkData.forEach(function(d, i) {
            if(typeof d.target === 'string') {
                linkData[i].target = globals._data.master.events.filter(function(l) { return d.target === l.id; })[0];
            }

            if(typeof d.source === 'string') {
                linkData[i].source = globals._data.master.people.filter(function (l) { return d.source === l.id; })[0];
            };

            if(currentEvent.substr(0,3) === 'per') {

                item = globals._data.master.events.filter(function (l) {
                    if (typeof d.target === 'string') {
                        return l.id === d.target;
                    } else {
                        return l.id === d.target.id;
                    }
                })[0];

                linkPeople.push(item)
            } else if(currentEvent.substr(0,3) === 'evt') {
                item = globals._data.master.people.filter(function (l) {
                    if (typeof d.source === 'string') {
                        return l.id === d.source;
                    } else {
                        return l.id === d.source.id;
                    }
                })[0];
                linkPeople.push(item)
            }
		})

		return {links: linkData, items: linkPeople};
	}

	var linksVisible = false;
    var bigLinks;

    function showLinksClick(d) {
    //	bigLinks = false

        if(currentEvent.substr(0,3) === 'per') {
            labelTxt = globals.copy.showLinksBtn;
            fieldRef = 'target';
        } else {
            labelTxt = globals.copy.showAttendeesBtn;
            fieldRef = 'source';
        }

    	if(linksVisible) {
    		removeLinkBubbles();
    		rotation = 0;
            d3.select(this).style("background-image", "url('media/images/plus_icon.png')")
                .select("p.button-label")
                .html(labelTxt)

            d3.select("div.bio-button .button-label").html(globals.copy.readBio)

			linksVisible = false;
            return
		} else {
    		linksVisible = true;
    		d3.select(this).style("background-image", "url('media/images/close_icon.png')")
                .select("p.button-label")
                .html("")

            d3.select("div.bio-button .button-label").html("")

        }

		$(".extra-bubble").fadeOut();

		raw = findItemData()
        obj = [];
		raw.links.forEach(function(d) {
		    console.log(d[fieldRef].id)
		    if(!utils.checkExists(d[fieldRef].id, obj, fieldRef)) {
		        obj.push(d)
            }
        })
		linkData = obj;
		linkPeople = raw.items;

        obj = findItemData();
        linkData = obj.links;
        linkPeople = obj.items;

		console.log(obj)

        if(linkData.length > 8) {
			bigLinks = true;
			$("#right-arrow").attr("data-len", linkData.length);
			d3.select(".data-container.main").transition()
				.style("opacity", "0")
				.on("end", function() {
					d3.select(this)
						.style("top", "320px")
						.style("padding", "0% 15%")
				})

            d3.select(".central-bubble .bubble-image").transition().style("opacity", "0")




        	d3.select(".central-bubble").transition()
				.duration(800)
				.on("end", addLinkBubbles)
				.style("top", "-250px")
				.style("width", "500px")
				.style("height", "500px")
				.style("border-radius", "250px")
                .style("left", window.innerWidth/2 - 250 + "px")

            attendeesButton.transition()
                .style("display", "none")

			d3.select("div.bio-button").transition()
				.style("display", "none")
			/*	.on("end", function() {
					d3.select(this).remove()
				})
*/
		} else {
			 bigLinks = false;
			 if(linkData.length === 0) {
			     console.log("nopeople")
			     linkBubbles = info.append("div")
                     .attr("class", "item-bubble")
                     .style("position", "absolute")
                     .style("top", (window.innerHeight / 2) - 75 + "px")
                     .style("left", (window.innerWidth / 2) - 75 + "px")
                     .append("div")
                     .attr("class", "bubble-image")
                     .style("background-image", "url(media/images/person.png)")
                     .append("div")
                     .attr("class", "data-container")
                     .append("p")
                     .html(globals.copy.missingPerson)

             } else {
                 if(currentEvent.substr(0,3) === "evt") {
                     classRef = 'person';
                 } else {
                     classRef = 'event';
                 }
                 linkBubbles = info.data(linkData)
                     .enter().append("div")
                     .attr("id", function (d, i) {
                         return "item" + String(i);
                     })
                     .attr("class", "item-bubble " + classRef)
                     .style("position", "absolute")
                     .style("top", (window.innerHeight / 2) - 75 + "px")
                     .style("left", (window.innerWidth / 2) - 75 + "px")
                     .on("click", linkBubbleClick)

                 linkBubbles.append("div")
                     .attr("class", "bubble-image")
                     .style("background-image", function (d) {
                         if (currentEvent.substr(0, 3) === 'evt') {
                             img = linkPeople.filter(function (l) {
                                 return l.id === d.source.id;
                             })[0].image;
                             /*if (img !== "person") {
                                 return "url(media/images/" + img + ".png)";
                             } else {
                                 return ""
                             }*/
                             return "url(media/images/" + img + ".png)";
                         } else {
                             return ""
                         }
                     })

                 linkBubbles.append("div")
                     .attr("class", "data-container")
                     .append("p")
                     .html(function (d) {
                         if (currentEvent.substr(0, 3) === 'evt') {
                             return linkPeople.filter(function (l) {
                                 return l.id === d.source.id;
                             })[0].name;
                         } else if (currentEvent.substr(0, 3) === 'per') {
                             return linkPeople.filter(function (l) {
                                 return l.id === d.target.id;
                             })[0].eventName;
                         }
                     })

                 linkBubbles.select(".data-container").append("p")
                     .attr("class", "info-relation")
                     .html(function (d) {
                         return d.relEs;
                     })

             }

			 $(".data-container:not(.back-to-container)").each(function() {
			 	utils.verticalCenter($(this), $(this).parent())
			 })

        /*    if(currentEvent.substr(0,3) === 'evt') {

                linkBubbles.append("p")
                    .html(function (d) {
                        return linkPeople.filter(function (l) {
                            return l.id === d.source.id;
                        })[0].name;
                    })

            } else if(currentEvent.substr(0,3) === 'per') {
                linkBubbles.append("p")
                    .html(function (d) {
                        return linkPeople.filter(function (l) {
                            return l.id === d.target.id;
                        })[0].eventName;
                    })
			}*/

	/*		linkBubbles.append("p")
                .attr("class", "info-relation")
                .html(function(d) { return d.relEs;})
*/
			linkBubbles.transition().duration(800)
                .style("left", function (d, i) {
                    angle = (2*Math.PI) / linkData.length
                    return (window.innerWidth / 2 - 75) + (270 * Math.cos(i*angle)) + "px";
                })
                .style("top", function (d, i) {
                    angle = (2*Math.PI) / linkData.length
                    return (window.innerHeight / 2 - 75) - (270 * Math.sin(i*angle)) + "px";
                })
        }

        if(currentEvent.substr(0,3) === 'evt') {
            linkObj = analyse.findAttendees(currentEvent, globals._data);
            globals._data.nodesData = globals._data.nodesData.concat(linkObj.newPeople)
            globals._data.linksData = globals._data.linksData.concat(linkObj.newLinks);
            updateNetwork();
        } else if(currentEvent.substr(0,3) === 'per') {
//            newLinks = globals._data.master.links.filter(function(d) { return d.source == currentEvent;} );
            linkData.forEach(function(d) {
                if(utils.checkExists(globals._data.linksData, d.id, 'id') === false) {
                    globals._data.linksData.push(d);
                }
            });
            updateNetwork();
		}

	}

	function removeLinkBubbles() {
    	console.log(bigLinks)
    	if(bigLinks) {
    		$("#left-arrow, #right-arrow").fadeOut();
            linkBubbles.transition()
                .style("top", (0) - 75 + "px")
                .style("left", (window.innerWidth / 2) - 75 + "px")
                .on("end", function () {
                    d3.select(this).remove();
                })

            attendeesButton.transition()
                .style("display", "none")
				.on("end", function() {
					d3.select(this).style("left", (window.innerWidth/2 - 40) + (150 * Math.cos(theta[2])) + "px")
						.style("top", (window.innerHeight/2 - 40) - (150 * Math.sin(theta[2])) + "px")
				})

            d3.select("div.data-container.main").transition()
                .style("display", "none")

            d3.select(".central-bubble").transition()
                .duration(800)
                .style("top", window.innerHeight/2 - 150 + "px")
                .style("width", "300px")
                .style("height", "300px")
                .style("border-radius", "150px")
                .style("left", window.innerWidth/2 - 150 + "px")
                .on("end", function() {
                    $(".extra-bubble").fadeIn();
                    utils.verticalCenter($(".data-container.main"), $(".data-container.main").parent())
                    attendeesButton.transition()
                        .style("display", "block")

                    bioButton.transition().style("display", "block")
					d3.select("div.data-container.main").transition()
						.style("display", "block")

                    d3.select(".central-bubble .bubble-image").transition().style("opacity", "0.2")

                })


        } else {
            linkBubbles.transition()
                .style("top", (window.innerHeight / 2) - 75 + "px")
                .style("left", (window.innerWidth / 2) - 75 + "px")
                .on("end", function () {
                    d3.select(this).remove();
                })

            $(".extra-bubble").fadeIn();

        };

    }

	function showEvents() {

	}

	function addLinkBubbles() {
    	d3.select(".data-container.main").transition()
			.style("opacity", "1")

		attendeesButton
            .style("left", (window.innerWidth/2 - 30) + (250 * Math.cos(theta[15])) + "px")
            .style("top", (0 - 30) - (250 * Math.sin(theta[15])) + "px")
			.transition()
			.style("display", "block")

        if(currentEvent.substr(0,3) === "evt") {
    	    classRef = 'person';
        } else {
    	    classRef = 'event';
        }

        linkBubbles = info.data(linkData)
            .enter().append("div")
			.attr("id", function(d, i) { return "item" + String(i)})
            .attr("class", "item-bubble " + classRef)
            .style("position", "absolute")
			.style("top", "0px")
			.style("left", window.innerWidth /2 + "px")
			.on("click", linkBubbleClick)

        linkBubbles.append("div")
            .attr("class", "bubble-image")
            .style("background-image", function(d) {
                if(currentEvent.substr(0,3) == 'evt') {

                    img = linkPeople.filter(function (l) { return l.id == d.source.id; })[0].image;
                    /*if (img != "person") {
                        return "url(media/images/" + img + ".png)";
                    } else {
                        return ""
                    }*/
                    return "url(media/images/" + img + ".png)";
                } else {
                	return "";
				}
            })

        linkBubbles.append("div")
            .attr("class", "data-container")
            .append("p")
            .html(function (d) {
                if(currentEvent.substr(0,3) === 'evt') {
                    return linkPeople.filter(function (l) {
                        return l.id === d.source.id;
                    })[0].name;
                } else if(currentEvent.substr(0,3) === 'per') {
                    return linkPeople.filter(function (l) {
                        return l.id === d.target.id;
                    })[0].eventName;
                }
            })

        linkBubbles.select(".data-container").append("p")
            .attr("class", "info-relation")
            .html(function(d) { return d.relEs;})

        $(".data-container:not(.main, .back-to-container)").each(function() {
            utils.verticalCenter($(this), $(this).parent())
        })
		/*

        linkBubbles.append("p")
            .html(function(d) {
                if(currentEvent.substr(0,3) == 'evt') {
                    return linkPeople.filter(function (l) { return l.id == d.source.id; })[0].name;
                } else {
                	return linkPeople.filter(function(l) { return l.id == d.target.id; })[0].eventName;
				}
            })

        linkBubbles.append("p")
            .attr("class", "info-relation")
            .html(function(d) { return d.relEs;})


*/
		sl = 0;

		linkBubbles.transition(2000).ease(d3.easeLinear)
            .style("left", function (d, i) {
                angle = (2*Math.PI) / linkData.length
                return (window.innerWidth/2 - 75) + (400 * Math.cos(i*angle)) + "px";
            })
            .style("top", function (d, i) {
                angle = (2*Math.PI) / linkData.length;
                yVal = -125 - (400 * Math.sin(i*angle));
                if(yVal > -75) {
                    sl++;
                }
                return yVal + "px";
            })
			.on("end", function() {
				$("#left-arrow").fadeIn();
                $("#right-arrow").attr("data-sl", sl);

			})
	}

	var rotation = 0;

	function rotateLinkBubbles(direction) {

		if(direction === 'right') {
            rotation++;
        } else {
			rotation--;
		}

        noBubbles = $("#right-arrow").attr("data-len");
		sl =  $("#right-arrow").attr("data-sl");
		stopLen = noBubbles -  sl;
		console.log(noBubbles)
        console.log(sl)
		console.log(stopLen)
        console.log(rotation)

		if(rotation > 0) {
            $("#right-arrow").fadeIn();
        } else if (rotation <= 0) {
		    $("#right-arrow").fadeOut();
        }

        if (rotation >= stopLen) {
		    console.log("OUT")
		    $("#left-arrow").fadeOut()
        } else if (rotation < stopLen) {
		    console.log("IN")
		    $("#left-arrow").fadeIn();
        }

        linkBubbles.transition(2000).ease(d3.easeLinear)
            .style("left", function (d, i) {
                angle = (2*Math.PI) / linkData.length
                return (window.innerWidth/2 - 75) + (400 * Math.cos((i+rotation)*angle)) + "px";
            })
            .style("top", function (d, i) {
                angle = (2*Math.PI) / linkData.length
                return -125 - (400 * Math.sin((i+rotation)*angle)) + "px";
            })
	}

	var relatedRotation = 0;

	function rotateRelatedBubbles(direction) {

		if(direction == 'right') {
			relatedRotation++;
            relatedRotation++;
        } else {
			relatedRotation--;
            relatedRotation--;
        }

        if(relatedRotation < 0) {
			$("#related-up-arrow").fadeIn();
		} else if (relatedRotation >= 0) {
			$("#related-up-arrow").fadeOut();
			console.log(rSources.data)
		}

		stopLen = ($("#related-down-arrow").attr("data-len")*2)-4
		console.log(stopLen)

		if (relatedRotation === 0 - stopLen) {
			$("#related-down-arrow").fadeOut()
		} else {
            $("#related-down-arrow").fadeIn()
        }

        rSources.transition(1500)
            .style("left", function (d, i) {
                return window.innerWidth - (350 * Math.cos(theta[i * 2 + 1 + relatedRotation])) + "px";
            })
            .style("top", function (d, i) {
                return window.innerHeight - (350 * Math.sin(theta[i * 2 + 1 + relatedRotation])) + "px";
            })
	}

	$("#left-arrow").click(function() {
		rotateLinkBubbles('right')
	})

    $("#right-arrow").click(function() {
        rotateLinkBubbles('left')
    })

	$("#related-up-arrow").click(function() {
		rotateRelatedBubbles('right')
	})

    $("#related-down-arrow").click(function() {
        rotateRelatedBubbles('left')
    })

	personInfoTemplates = {
    	dataset: "{{copy.dataset1}}<br/><a class='uppercase'>{{dataset}}</a>{{copy.dataset2}} {{#relationship}}{{copy.dataset3}} <a class='uppercase'>{{.}}</a>{{/relationship}}",
		profession: "{{copy.professionTag}}<br/><a class='uppercase'>{{profession}}</a>",
		location: "{{copy.residenceTag}}<br/><a class='uppercase'>{{location}}</a>"
	}

	function linkBubbleClick(d) {
 //   	console.log(d.target.id)

        rotation = 0;
        if(currentEvent.substr(0,3) == 'evt') {
            currentEvent = d.source.id
            labelTxt = globals.copy.showLinksBtn;
        } else {
            currentEvent = d.target.id
            labelTxt = globals.copy.showAttendeesBtn;
        }

        $(".arrow").fadeOut();

        attendeesButton
			.transition()
            .style("display", "none")
			.on("end", function() {
                d3.select(this).style("left", (window.innerWidth/2 - 40) + (150 * Math.cos(theta[2])) + "px")
                    .style("top", (window.innerHeight/2 - 40) - (150 * Math.sin(theta[2])) + "px")
                    .style("background-image", "url('media/images/plus_icon.png')")
                    .select(".button-label")
                    .html(labelTxt)
            })

		linksVisible = false

		d3.select("div.bio-button").transition()
			.style("display", "none")
			.on("end", function() { d3.select(this).remove(); })
/*
		d3.select(".back-to-bubble").transition()
			.attr("opacity", "0")
*/
    	elId = this.id
    	d3.selectAll(".item-bubble:not(#"+elId+")").transition()
			.style("opacity", "0")

		relatedSources.transition()
            .style("opacity", "0")

		d3.select(this).selectAll("p")
			.transition()
			.style("opacity", "0")
//			.attr("class", "info-name")

		console.log(d)
		if(currentEvent.substr(0,3) === 'per') {
            d3.select(this).select("p.info-relation")
                .style("display", "none")
        } else {
            if(!d3.select(this).classed("back-to-bubble")) {
                d3.select(this).select(".data-container")
                    .insert("p", ":first-child")
                    .attr("class", "info-date")
                    .style("opacity", "0")
                    .html(function (d) {
                        return d.target.date !== '' ? d.target.date : d.target.startDate + " - " + d.target.endDate;
                    })
            }

        	d3.select(this).select("p.info-relation")
				.html(d.target.venue)
		}

		d3.select(this).select("div.bubble-image")
            .transition().duration(1000)
            .style("width", "290px")
            .style("height", "290px")
            .style("border-radius", "145px")
            .style("opacity", "0.2")
//            .style("background-color", " #5342b7")
//            .style("top", window.innerHeight/2 - 150 + "px")
//            .style("left", window.innerWidth/2 - 150 + "px")
//            .style("padding", "70px 40px")

        if(currentEvent.substr(0,3) === "per") {
            classRef = 'person';
        } else {
            classRef = 'event';
        }

    	d3.select(this)
			.transition().duration(1000)
            .style("width", "300px")
            .style("height", "300px")
            .style("border-radius", "150px")
//			.style("background-color", " #5342b7")
			.style("top", window.innerHeight/2 - 150 + "px")
            .style("left", window.innerWidth/2 - 150 + "px")
			.on("end", function() {
				$(".data-container.main").removeClass("main")
				d3.select(this).attr("class", "central-bubble " + classRef)
				d3.select(this).select("div.data-container")
					.attr("class", "data-container main")
				d3.select(this).select("p:not(.info-date)")
                    .style("font-size", function() { return currentEvent.substr(0,3) === 'per' ? "2em": "1.5em"})
					.style("line-height", "1em")
					.style("text-align", "center")
//					.style("margin-top", "-100px")

				utils.verticalCenter($(".data-container.main"), $(".data-container.main").parent())

				d3.select(this).selectAll("p")
					.transition(800)
					.style("opacity", "1")

                attendeesButton.transition()
					.style("display", "block")

				if(currentEvent.substr(0,3) == 'per') {
					addPersonInfo(d.source);
				} else {
                    if(d.target.relMedia.length > 0) {
                        showRelSources(d.target.relMedia);
                    }
				}
			})


        if(d3.select(this).classed("back-to-bubble")) {
    	    d3.select(this).classed("back-to-people", false)
            d3.selectAll(".central-bubble,.extra-bubble").transition()
                .style("opacity", "0")
                .on("end", function() {
                    d3.select(this).remove();
                })
        } else {
    	    d3.selectAll(".central-bubble .bubble-image").transition().duration(1000).style("opacity", "0")

            d3.selectAll(".central-bubble").transition().duration(1000)
                .style("width", "400px")
                .style("height", "400px")
                .style("border-radius", "200px")
                .style("top", window.innerHeight - 200 + "px")
                .style("left", "-200px")
                .on("end", function () {
                    d3.select(this).classed("central-bubble", false)
                        .attr("class", "back-to-bubble")
                        .select(".data-container").style("top", "-75px").style("padding", "0% 2%")

                    d3.select(this).on("click", linkBubbleClick)

                    d3.select(this).select(".data-container").classed("main", false).classed("back-to-container", true).style("top", "-75px")

                })
        }

        d3.select(".central-bubble").selectAll("p").transition()
			.style("opacity", "0")
			.on("end", function() {
                d3.select(this)
                    .transition(1000).delay(800)
                    .style("opacity", "0.5")
                    .style("text-align", "left")

/*                d3.select(".central-bubble").select(".info-date")
                    .style("width", "150px")
                    .style("float", "right")
                    .style("text-align", "left")

                d3.select(".central-bubble").select(".info-name")
                    .style("width", "150px")
                    .style("float", "right")
                    .style("text-align", "left")
                    .style("font-size", "1.2em")
                    .style("clear", "both")
*/

			})

	}

	function addPersonInfo(d) {
        console.log(d)
        if(d.bioEn !== "") {
            bioButton = infoLayer.append("div")
                .attr("class", "bubble-button bio-button")
                .style("position", "absolute")
                .style("left", (window.innerWidth / 2 - 40) + (150 * Math.cos(0.35)) + "px")
                .style("top", (window.innerHeight / 2 - 40) - (150 * Math.sin(0.35)) + "px")
                .on("click", showBio);

            bioButton.append("p")
                .attr("class", "button-label")
                .html(globals.copy.readBio)
        }

        extraData = []
        extraData.push(Mustache.render(personInfoTemplates["dataset"], {dataset: protagonists[d.datasets[0]], relationship: utils.splitList(d.relProtagonist), copy:globals.copy}));
        extraData.push(Mustache.render(personInfoTemplates["profession"], {profession: utils.splitList(d.proffesion), copy:globals.copy}));
        extraData.push(Mustache.render(personInfoTemplates["location"], {location: d.residence, copy:globals.copy}));

        infoLayer.append("div")
            .attr("class", "extra-bubble")
            .style("position", "absolute")
            .style("left", (window.innerWidth/2 - 60) + (230 * Math.cos(theta[4])) + "px")
            .style("top", (window.innerHeight/2 - 60) - (230 * Math.sin(theta[4])) + "px")
            .append("p")
            .html(extraData[0])

        if(d.proffesion !== "") {
            infoLayer.append("div")
                .attr("class", "extra-bubble")
                .style("position", "absolute")
                .style("left", (window.innerWidth / 2 - 60) + (230 * Math.cos(theta[5])) + "px")
                .style("top", (window.innerHeight / 2 - 60) - (230 * Math.sin(theta[5])) + "px")
                .append("p")
                .html(extraData[1])
        }

        if(d.residence !== "") {
            infoLayer.append("div")
                .attr("class", "extra-bubble")
                .style("position", "absolute")
                .style("left", (window.innerWidth / 2 - 60) + (230 * Math.cos(theta[7])) + "px")
                .style("top", (window.innerHeight / 2 - 60) - (230 * Math.sin(theta[7])) + "px")
                .append("p")
                .html(extraData[2])
        }
        //console.log(d)

		$(".extra-bubble p").each(function() {
			utils.verticalCenter($(this), $(this).parent())
        });

        if(d.relMedia.length > 0) {
            showRelSources(d.relMedia);
        }
	}

	function showBio() {

    	bioText = globals._data.master.people.filter(function(d) { return d.id === currentEvent})[0].bioEn

    	bio = infoLayer.append("div")
			.attr("class", "bio-container")
			.append("p")
			.html(bioText)

		utils.verticalCenter($('.bio-container p'), $('.bio-container'))

		diameter = window.innerHeight * 0.8;

		infoLayer.append("div")
            .attr("class", "bubble-button close-button")
            .style("position", "fixed")
            .style("left", (window.innerWidth/2 - 40) + (diameter/2 * Math.cos(theta[2])) + "px")
            .style("top", (window.innerHeight/2 - 40) - (diameter/2 * Math.sin(theta[2])) + "px")
            .on("click", function() {
            	d3.select(this).remove();
            	d3.select("div.bio-container").remove();
			});
	}

/*
    function personClick(d) {
	$(".info-container").remove();
	eventX = positionInfo(d.x,'x');
	eventY = positionInfo(d.y,'y');
	$(".selected").removeClass("selected");
	d3.select(this).attr("class", "selected")
	
	if(d.relProtagonist == '') {
	    d.relProtagonist = 'unkown relation';
	}
	
	person = {
	    id: d.id,
	    name: d.name,
	    copy: globals.copy,
	}
	
	$.ajax({
	    url:'templates/personInfo.html',
	    cache:false,
	}).done(function(data) {
	    $('#timeline-container').append(Mustache.render(data, person));
	    $(".info-container").css("left", eventX+"px").css("top", eventY+"px")
	    $(".info-container").fadeIn();
	    $(".close-btn").click(function() {
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	    $(".action-btn.show-links").click(function() {
		id = $(this).parent().attr("data-id");
		newLinks = globals._data.master.links.filter(function(d) { return d.source == id;} );
		newLinks.forEach(function(d) {
		    if(utils.checkExists(globals._data.linksData, d.id, 'id') == false) {
			globals._data.linksData.push(d);
		    }
		});
		updateNetwork();
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	    $(".action-btn.remove-person").click(function() {
		id = $(this).parent().attr("data-id");
		globals._data.linksData = globals._data.linksData.filter(function(d) { return d.source != id;});
		globals._data.nodesData = globals._data.nodesData.filter(function(d) { return d.id != id;});
		updateNetwork();
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	}); 
    }
*/
    var posVals = {x:{edge:555, offset:350},y:{edge:300, offset:150}}
    
    function positionInfo(val, axis) {
	horizontalAdjust = axis == 'x' ? $(window).scrollLeft() : 0;
	return val > posVals[axis].edge ? val - posVals[axis].offset - horizontalAdjust  : val + 80;
    }

    
    function fixEvents() {
		globals._data.nodesData.filter(function(d) { return d.type == 'event'; }).forEach(function(e) {
	    e.fy = e.y;
	})
//	    .attr("fy", function(d) { return d.y; })
    }

    function checkCats(val) {
	return utils.checkExists(val, currentCats, 'title');
    }


    
})();
